import styles from "./styles.module.css";

export const Loading: React.FC = () => {
  return (
    <div className={styles.root} data-testid="loading-overlay">
      <div className={styles.loading_spinner} />
    </div>
  );
};
